module.exports = __webpack_public_path__ + "img/4-3-2.052cef8f.png";